import {
  FaCloud,
  FaTachometerAlt,
  FaArrowsAltH,
  FaShieldAlt,
  FaKey,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-minio.png";

export const MINIO_CONSTANTS = {
  HERO: {
    title: "OneMind Services — MinIO Object Storage (One-Click Application) ",
    desc: "High-performance object storage that’s S3 compatible, purpose-built for large-scale data infrastructure.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "MinIO is a high-performance, open-source object storage system released under the GNU AGPL v3.0 license. It is fully compatible with the Amazon S3 API, enabling seamless integration with existing S3 tools and applications. Designed for speed and scalability, MinIO is ideal for unstructured data such as photos, videos, log files, backups, and container images.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure MinIO instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high.  ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes MinIO server, default admin credentials, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "minioadmin",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access the MinIO Console at: ",
      command: "http://<YOUR_INSTANCE_IP>:9000  ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration files are located in the directory",
      location: "/etc/minio/ ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: ["9000 (MinIO API & Console)"],
    },
    note: "Note : Find the configuration files at /etc/minio/ for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaCloud,
        title: "S3 Compatibility",
        text: "Fully compatible with Amazon S3 APIs, allowing seamless integration with existing S3 tools and applications.",
      },
      {
        icon: FaTachometerAlt,
        title: "High Performance",
        text: "Engineered for high throughput and low latency, making it suitable for demanding workloads.",
      },
      {
        icon: FaArrowsAltH,
        title: "Scalability",
        text: "Supports horizontal scaling through distributed architecture, accommodating growing data needs.",
      },
      {
        icon: FaShieldAlt,
        title: "Data Protection",
        text: "Implements erasure coding and bitrot protection to ensure data integrity and durability.",
      },
      {
        icon: FaKey,
        title: "Security",
        text: "Offers end-to-end encryption, access control policies, and identity management features.",
      },
    ],
    columns: { base: 1, sm: 2, md: 3, lg: 5 },
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for MinIO data and configurations.",
      },
      {
        label: "Security Out of the Box",
        text: " Hardened with firewall rules, TLS ready, and access control configurations.  ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with distributed setups for enhanced performance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "MinIO Documentation",
    docsLink: "https://min.io/docs/minio/kubernetes/upstream/index.html",
  },
};
